import { defaultAccessValue, defaultDisplayValue, defaultMakeReactKey } from '#helpers/helpers.js';
import Select from '#lib/components/select.jsx';
import { cn, mergeClasses } from '#lib/helpers/class.js';
import { CheckIcon } from '@heroicons/react/24/outline';

export function PlacesDropdown(props) {
    const { options, bg = 'primary', optionClassName, ...rest } = props;
    const locations = [];
    options.forEach((option) => {
        if (locations.includes(option.place)) return;
        locations.push(option.place);
    });
    return (
        <Select.Full {...props}>
            {locations.map((location) => {
                const filteredOptionsPerLocations = options.filter((option) => option.place === location);
                const categories = [];
                filteredOptionsPerLocations.forEach((option) => {
                    if (categories.includes(option.filterName)) return;
                    categories.push(option.filterName);
                });
                return (
                    <div key={location}>
                        <Select.Option bg={bg} className="pl-4 py-2 text-sm font-semibold underline">
                            {location}
                        </Select.Option>
                        {categories.map((category) => {
                            const filteredOptionsPerCategory = filteredOptionsPerLocations.filter(
                                (option) => option.filterName === category
                            );
                            return (
                                <div key={category}>
                                    <Select.Option bg={bg} className="pl-6 py-2 text-sm font-semibold">
                                        {category}
                                    </Select.Option>
                                    {filteredOptionsPerCategory.map((option) => {
                                        const value = defaultAccessValue(option, options);
                                        return (
                                            <Select.Option
                                                bg={bg}
                                                className={(prev) =>
                                                    mergeClasses(
                                                        `${prev.replaceAll('primary', bg)} flex items-center`,
                                                        optionClassName
                                                    )
                                                }
                                                key={defaultMakeReactKey(option, options)}
                                                value={value}
                                            >
                                                {({ selected, active }) => (
                                                    <>
                                                        <CheckIcon
                                                            className={cn(
                                                                selected ? 'visible' : 'invisible',
                                                                active ? `text-${bg}-700` : `text-${bg}-600`,
                                                                '-ml-2 mr-2 h-5 w-5 flex-shrink-0'
                                                            )}
                                                        />
                                                        {defaultDisplayValue(value, options)}
                                                    </>
                                                )}
                                            </Select.Option>
                                        );
                                    })}
                                </div>
                            );
                        })}
                    </div>
                );
            })}
        </Select.Full>
    );
}
